import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';

const formatNumber = (n) => {
    if (n == null) return '—';
    return new Intl.NumberFormat('es-AR').format(n);
};

const formatPct = (n) => {
    if (n == null) return null;
    const sign = n > 0 ? '+' : '';
    return `${sign}${n.toFixed(1)}%`;
};

const StatsKpiCard = ({ label, value, hint, delta, color = 'accent', icon: Icon, loading }) => {
    const trendIcon = delta == null
        ? <Minus size={12} />
        : delta > 0
            ? <ArrowUp size={12} />
            : delta < 0
                ? <ArrowDown size={12} />
                : <Minus size={12} />;
    const trendClass = delta == null
        ? 'stats-kpi__trend--neutral'
        : delta > 0
            ? 'stats-kpi__trend--up'
            : delta < 0
                ? 'stats-kpi__trend--down'
                : 'stats-kpi__trend--neutral';

    return (
        <article className={`stats-kpi stats-kpi--${color}`}>
            <div className="stats-kpi__top">
                <div className="stats-kpi__label">{label}</div>
                {Icon && (
                    <div className="stats-kpi__icon">
                        <Icon size={16} />
                    </div>
                )}
            </div>
            <div className="stats-kpi__value">
                {loading ? <span className="stats-kpi__skeleton" /> : formatNumber(value)}
            </div>
            <div className="stats-kpi__footer">
                {!loading && delta !== undefined && (
                    <span className={`stats-kpi__trend ${trendClass}`}>
                        {trendIcon}
                        <span>{formatPct(delta) ?? '—'}</span>
                    </span>
                )}
                {hint && <span className="stats-kpi__hint">{hint}</span>}
            </div>
        </article>
    );
};

export default StatsKpiCard;
